import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const PointByPointWidgetAsyncComponent = AsyncComponent(async () => import('./point-by-point-widget' /* webpackChunkName: "template-widget" */ ));

export const PointByPointWidgetAsync = (props) => {
  return <PointByPointWidgetAsyncComponent {...props}/>
};
